import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "e-shop-status-component" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Eshop Import ")
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { style: {"margin-top":"16px"} }, "Eshop Import", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "ant-pro-table-list-toolbar" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "ant-pro-table-list-toolbar-container",
    style: {"display":"flex"}
  }, [
    /*#__PURE__*/_createVNode("div", { class: "ant-pro-table-list-toolbar-left" }, [
      /*#__PURE__*/_createVNode("div", { class: "ant-pro-table-list-toolbar-title" }, "Trigger Import")
    ])
  ])
], -1)
const _hoisted_5 = { style: {"padding-left":"20px !important","padding-bottom":"20px !important"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Trigger Import")
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "ant-pro-table-list-toolbar" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "ant-pro-table-list-toolbar-container",
    style: {"display":"flex"}
  }, [
    /*#__PURE__*/_createVNode("div", { class: "ant-pro-table-list-toolbar-left" }, [
      /*#__PURE__*/_createVNode("div", { class: "ant-pro-table-list-toolbar-title" }, "Last 100 Eshop Import Status")
    ])
  ])
], -1)
const _hoisted_8 = {
  key: 1,
  style: {"font-style":"italic","color":"gray"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_extension_table_outlined = _resolveComponent("extension-table-outlined")
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_card = _resolveComponent("a-card")
  const _component_a_table = _resolveComponent("a-table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_breadcrumb, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_breadcrumb_item, { href: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_extension_table_outlined),
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode(_component_a_card, {
      style: {"margin-top":"16px"},
      "body-style": { padding: 0 }
    }, {
      default: _withCtx(() => [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.triggerImport()))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, {
      style: {"margin-top":"16px"},
      "body-style": { padding: 0 }
    }, {
      default: _withCtx(() => [
        _hoisted_7,
        _createVNode(_component_a_table, {
          size: 'small',
          loading: _ctx.loadingTable,
          columns: _ctx.columns,
          "data-source": _ctx.rows,
          pagination: _ctx.pagination,
          onChange: _ctx.handleTableChange
        }, {
          image: _withCtx(({ record }) => [
            _createVNode("a", {
              href: record.signed_image,
              target: "_blank",
              style: {"float":"left"}
            }, [
              _createVNode("img", {
                src: record.signed_image,
                alt: record.name,
                style: {"max-width":"100px","max-height":"100px","display":"block"}
              }, null, 8, ["src", "alt"])
            ], 8, ["href"])
          ]),
          viewMore: _withCtx(({ record }) => [
            (!record.deleteLoading)
              ? (_openBlock(), _createBlock("a", {
                  key: 0,
                  href: "#",
                  style: {"color":"red"},
                  onClick: _withModifiers(($event: any) => (_ctx.deleteRow(record)), ["prevent"])
                }, "Delete", 8, ["onClick"]))
              : _createCommentVNode("", true),
            (record.deleteLoading)
              ? (_openBlock(), _createBlock("a", _hoisted_8, "Deleting..."))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "columns", "data-source", "pagination", "onChange"])
      ]),
      _: 1
    })
  ]))
}